import { styled } from '@mui/material/styles';
import { Box, Button, Dialog } from '@mui/material';

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    maxWidth: '620px',
    width: '620px',
    overflow: 'hidden',
    borderRadius: '16px',
    padding: '32px',
    background: '#FFFFFF',
    boxSizing: 'border-box',
    position: 'relative',
  },
}));

export const CloseIconBox = styled(Box)({
  position: 'absolute',
  top: 24,
  right: 24,
  fontSize: '24px',
  cursor: 'pointer',
  color: '#75838A',
  '&:hover': {
    color: '#E85E51',
  },
});

export const HeaderBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '24px',
});

export const AlertIcon = styled(Box)<{ iconColor?: string }>(
  ({ iconColor = '#FFA500' }) => ({
    fontSize: '24px',
    color: iconColor,
    marginRight: 12,
  })
);

export const TitleText = styled(Box)({
  fontFamily: 'Lufga',
  fontSize: '24px',
  fontWeight: 500,
  color: '#0B2330',
});

export const Divider = styled(Box)({
  borderBottom: '1px solid #E5E7EB',
  marginBottom: '24px',
  width: '100%',
});

export const SubtitleText = styled(Box)({
  fontFamily: 'Outfit',
  fontSize: '16px',
  fontWeight: 600,
  color: '#0B2330',
  marginBottom: '8px',
});

export const SecondaryText = styled(Box)({
  fontFamily: 'Outfit',
  fontSize: '14px',
  fontWeight: 400,
  color: '#75838A',
  marginBottom: '32px',
});

export const ButtonContainer = styled(Box)({
  display: 'flex',
  gap: '12px',
});

export const ConfirmButton = styled(Button)<{ btnColor?: string }>(
  ({ btnColor = '#22C55E' }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px 32px',
    minWidth: 110,
    height: 40,
    background: btnColor,
    border: `1px solid ${btnColor}`,
    borderRadius: '8px',
    color: '#FFFFFF',
    fontFamily: 'Outfit',
    fontSize: '16px',
    fontWeight: 500,
    textTransform: 'none',
    '&:hover': {
      background: btnColor,
      filter: 'brightness(0.9)',
    },
    '&.Mui-disabled': {
      opacity: 0.5,
    },
  })
);

export const CancelButton = styled(Button)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '10px 32px',
  minWidth: 97,
  height: 40,
  background: '#F1F7FF',
  border: '1px solid #DFDFDF',
  borderRadius: '8px',
  color: '#75838A',
  fontFamily: 'Outfit',
  fontSize: '16px',
  fontWeight: 500,
  textTransform: 'none',
  '&:hover': {
    background: '#E8F2FF',
  },
});
